import { DocumentData, DocumentReference } from '@angular/fire/firestore';

export type subscriptionType = Record<
  string,
  DocumentReference<unknown, DocumentData> | string
>[];
export type Customer = {
  id?: string;
  email?: string;
  subscriptions: subscriptionType;
};
